import React from 'react';
import axios from 'axios';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import grey from '@material-ui/core/colors/grey';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import {withSnackbar} from 'notistack';
import {withTranslation} from 'react-i18next';
import PupilBadge from '../parts/PupilBadge';

const styles = theme => ({
  badgesNotFound: {
    color: grey[500]
  }
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
  };
};

class EventBadgesPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      isLoading: true,
      isLoaded: false,
      meta: [],
    };

    this.axiosCancel = null;
  }

  componentDidMount() {
    const {
      selectedPupil
    } = this.props;

    axios
      .get(
        `${window.apiUrl}/eventbadges/${selectedPupil.id}`,
        {
          cancelToken: new axios.CancelToken((c) => {
            this.axiosCancel = c
          }),
        }
      )
      .then(response => {
        if (response.data.success) {
          this.setState({
            data: response.data.data,
            meta: response.data.meta,
          });
        }

        this.setState({
          isLoading: false,
          isLoaded: true,
        });
      })
      .catch(thrown => {});
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  render() {
    const {
      data,
      isLoaded
    } = this.state;

    const {
      t,
      classes,
      selectedPupil,
    } = this.props;

    return (
      <div className="event-badges-page">
        {isLoaded && (
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={3}
          >
            {data.length === 0 && (
              <Grid
                item
                xs={12}
              >
                <Typography
                  variant="h5"
                  className={classes.badgesNotFound}
                  align="center"
                >
                  {
                    appType === 'parent'
                      ? t('{{name}} has not been awarded any badges', {name: selectedPupil.name})
                      : t('You have not been awarded any badges.')
                  }
                </Typography>
              </Grid>
            )}
            {data.length > 0 && data.map((badge) => (
              <Grid
                item
                xs={4}
                md={2}
                key={badge.id}
              >
                <PupilBadge
                  badge={badge}
                  useSuspense={false}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, null)(
  withStyles(styles)(withSnackbar(withTranslation()(EventBadgesPage)))
);
